module.exports = "../../static/img/logo-symbol.950bc15.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo-symbol.png
// module id = 1083
// module chunks = 0